import { render, staticRenderFns } from "./FileEntryPreview.vue?vue&type=template&id=1a58681f"
import script from "./FileEntryPreview.vue?vue&type=script&lang=ts"
export * from "./FileEntryPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports